export default __webpack_public_path__ + "static/media/hedgehog_fat_filled_transparent_black.db4b0c70.png";